import { useState } from "react";
import { toast } from "sonner";
import { Check, Loader2 } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { MEMBERSHIP } from "../data";
import { startCheckout } from "../lib/api";
import { PayPalButton } from "./PayPalButton";

export const ExecutiveClub = () => {
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(MEMBERSHIP.plans[0]);

  const join = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await startCheckout(plan.lookup);
      window.location.href = checkout_url;
    } catch {
      toast.error("Impossibile avviare l'iscrizione. Riprova.");
      setLoading(false);
    }
  };

  return (
    <section id="executive-club" data-testid="club-section" className="py-24 sm:py-32 bg-[var(--anthracite)] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="overline mb-6">Executive Club</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight mb-8">
            <RevealLine>Una community</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--accent)]">di chi decide.</RevealLine>
          </h2>
          <div className="space-y-4">
            {MEMBERSHIP.perks.map((p, i) => (
              <Reveal key={i} delay={i * 0.06} className="flex items-start gap-3">
                <Check size={18} strokeWidth={1.5} className="text-[var(--accent)] mt-1 shrink-0" />
                <span className="text-white/80">{p}</span>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="border border-white/15 p-10 bg-white/[0.03]">
          <div className="text-xs uppercase tracking-[0.15em] text-white/60 mb-4">Membership</div>

          {/* plan toggle */}
          <div className="inline-flex p-1 border border-white/15 mb-6" data-testid="plan-toggle">
            {MEMBERSHIP.plans.map((pl) => (
              <button key={pl.id} data-testid={`plan-${pl.id}`} onClick={() => setPlan(pl)}
                className={`px-5 py-2 text-xs font-semibold uppercase tracking-[0.15em] transition-[background-color,color] duration-300 ${
                  plan.id === pl.id ? "bg-[var(--gold)] text-[var(--anthracite)]" : "text-white/70 hover:text-white"
                }`}>
                {pl.id === "monthly" ? "Mensile" : "Annuale"}
              </button>
            ))}
          </div>

          <div className="flex items-end gap-2 mb-8">
            <span className="font-serif text-6xl">{plan.price}</span>
            <span className="text-white/60 mb-2">{plan.period}</span>
          </div>
          <button
            data-testid="join-club-btn"
            onClick={join}
            disabled={loading}
            className="btn-fill w-full inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] border border-white text-white hover:text-[var(--anthracite)] px-8 py-4 disabled:opacity-60"
            style={{ "--accent": "#ffffff" }}
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : "Entra nell'Executive Club"}
          </button>
          <div className="mt-3">
            <PayPalButton lookup_key={plan.lookup} subscription testid="paypal-club-btn" dark />
          </div>
          <p className="mt-4 text-xs text-white/40 text-center">{plan.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
